import React from "react";

const NoSubscriptionModal = ({ show, onClose, onSubscribe }) => {
  if (!show) return null;

  const buttonStyle = {
    border: "none",
    borderRadius: "10px",
    fontSize: "13px",
    padding: "10px 12px",
    fontWeight: 400,
    cursor: "pointer",
  };

  const subscribeBtnStyle = {
    ...buttonStyle,
    backgroundColor: "rgb(55 55 88)",
    color: "#fff", //. white text
  };

  const closeBtnStyle = {
    ...buttonStyle,
    backgroundColor: "#ccc",
    color: "#000",
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "30px",
          borderRadius: "8px",
          maxWidth: "500px",
          width: "90%",
          textAlign: "center",
          boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
        }}
      >
        <h4 style={{ marginBottom: "15px" }}>No Active Subscription</h4>
        <p style={{ marginBottom: "25px" }}>
          You do not have an active subscription yet. Please subscribe first to get admin approval for your stay listing.
        </p>
        <div style={{ display: "flex", justifyContent: "center", gap: "15px" }}>
          <button style={subscribeBtnStyle} onClick={onSubscribe}>
            Subscribe Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoSubscriptionModal;